import OffersTable from './offers-table';

export default OffersTable;
